module.exports = __webpack_public_path__ + "static/media/72_tn.9f3cc833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/72_tn.jpg
// module id = 558
// module chunks = 0